import { render, staticRenderFns } from "./AccountTop.vue?vue&type=template&id=4c9971e0&scoped=true"
import script from "./AccountTop.vue?vue&type=script&lang=js"
export * from "./AccountTop.vue?vue&type=script&lang=js"
import style0 from "./AccountTop.vue?vue&type=style&index=0&id=4c9971e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9971e0",
  null
  
)

export default component.exports